import { createContext, ReactNode, useEffect, useState } from "react";
import { exportFilterDTO, filterDTO, submitFilterDTO } from "../types";
import { isFiltersNullOrEmpty, isFilterUserTypedValueEmptyArray } from "../UtilFunctions";
import MapperFilterDTOtoExportFilterDTO from "./Mapper/FilterDTOtoExportFilterDTO";


const defaultFilterProps = {
    //setFilters: {},
    setFilterData: (filterData: filterDTO[]) => {},
    toggleFilterSidebar: () => {},
    changeFilters: (filters: submitFilterDTO | undefined) => {},
    isSliderFilterOpen: false,
    filterUrl: "",
    defaultOrderByKeyFilter: "",
    numberOfActiveFilters: 0,
    clearAllFilters: () => {},
    clearFilter: () => {},
    activeFilters: undefined,
    postFilterData: () => {},
    setAllFilters: (filters: filterDTO[] | undefined) => {},
    submitedFilters: undefined
}


export const FilterContext = createContext<IFilterContextType>(defaultFilterProps);

 const FilterProvider = (props : IFilterProviderProps) => {
    const [filterUrl, setFilterUrl] = useState<string>(props.FilterUrl);
    const [submitedFilters, setSubmitedFilters] = useState<submitFilterDTO | undefined>();
    const [isSliderFilterOpen, setIsSliderFilterOpen] = useState<boolean>(false);
    const [defaultOrderByKeyFilter, setDefaultOrderByKeyFilter] = useState(props.defaultOrderByKeyFilter);
    const [filterData, setFilterData] = useState<filterDTO[]>(props.filterData)
    const [numberOfActiveFilters, setNumberOfActiveFilters] = useState(0);
    const [activeFilters, setActiveFilters] = useState<filterDTO[] | undefined>(undefined);
    
    const toggleFilterSidebar = () => {
        setIsSliderFilterOpen(!isSliderFilterOpen);
    };

    const closeFilterSidebar = () =>{
        setIsSliderFilterOpen(false);
    }

    const getNumberOfActiveFilters = () => {
        const numberOfActiveFilters = activeFilters ? activeFilters.length : 0;
        setNumberOfActiveFilters(numberOfActiveFilters);
    }

    
    const changeFilters = (filters: submitFilterDTO | undefined) => {
        let tmpFilters: submitFilterDTO | undefined = undefined;
        tmpFilters = isFiltersNullOrEmpty(filters) ? undefined : filters

        setSubmitedFilters(filters);
        closeFilterSidebar();
    }

    const getDefaultOrderByKey = (): {[key: string]: string} => {
        let defaultKeyObj : {[key: string]: string;} = {}
        defaultKeyObj[defaultOrderByKeyFilter] = "ASC"; 
        return defaultKeyObj;
    }

    const getNextActiveFilters = (): filterDTO[] => {
        let newActiveFilters: filterDTO [] = [];

        if(filterData){
            filterData.filter((filter: filterDTO) => {
                if (filter.userValues != null && filter.userValues != undefined) {
                    if(!isFilterUserTypedValueEmptyArray(filter)){
                        newActiveFilters.push(filter); 
                    }
                }
            });
        }
        return newActiveFilters;
    }

    const postFilterData = () => {
        let exportFilterData: exportFilterDTO [] = []; 
        
        if(filterData){
            exportFilterData = MapperFilterDTOtoExportFilterDTO(filterData);
        }
        
        const submitFilter: submitFilterDTO | undefined = exportFilterData[0] ? {filters: [exportFilterData], sortOrder: getDefaultOrderByKey()} : undefined
        setActiveFilters(getNextActiveFilters());
        changeFilters(submitFilter);
        setSubmitedFilters(submitFilter);
    }

    const clearAllFilters = () => {
        const newFilterData = filterData?.map((filter: filterDTO) => { 
            filter.userValues = [];
            return filter;
        });
        
        setFilterData(newFilterData);
        setActiveFilters(undefined);
        setSubmitedFilters(undefined);
        //TODO Better way to hundle fetch api data again

        closeFilterSidebar();
    }

    const clearFilter = (removeFilter: filterDTO) => {
        const newFilterData = filterData?.map((filter: filterDTO) => { 
            if(filter.columnName === removeFilter.columnName){
                filter.userValues = [];
            }
            return filter;
        });

        const newActiveFilters = activeFilters?.filter((activeFilter: filterDTO) => activeFilter.columnName !== removeFilter.columnName);

        setFilterData(newFilterData);
        setActiveFilters(newActiveFilters);
        
        //TODO Better way to hundle fetch api data again
        postFilterData();
        //props.changeFilters(undefined);
    }

    const porviderValue = {
        submitedFilters, 
       // setFilters,
        filterData,
        setFilterData,
        toggleFilterSidebar, 
        isSliderFilterOpen, 
        filterUrl,
        defaultOrderByKeyFilter,
        numberOfActiveFilters,
        clearAllFilters,
        clearFilter,
        activeFilters,
        postFilterData,
    }

    useEffect(() => {
        getNumberOfActiveFilters()
        
      return () => {
        null
      }
    }, [activeFilters])
    
      
    return (
        <FilterContext.Provider value={porviderValue}>
            {props.children}
        </FilterContext.Provider>
    )
    
}

interface IFilterContextType {
    //setFilters: SetStateAction<submitFilterDTO | {}>;
    submitedFilters: submitFilterDTO | undefined;
    filterData?: filterDTO[];
    setFilterData: (data: filterDTO[]) => void;
    toggleFilterSidebar: () => void;
    isSliderFilterOpen: boolean;
    filterUrl: string;
    defaultOrderByKeyFilter: string;
    numberOfActiveFilters: number;
    clearAllFilters: () => void;
    clearFilter: (filter: filterDTO) => void;
    activeFilters: filterDTO[] | undefined;
    postFilterData: () => void;
}

interface IFilterProviderProps {
    children: ReactNode;
    FilterUrl: string;
    defaultOrderByKeyFilter: string;
    filterData: filterDTO[];
}

export default FilterProvider;
